import { Box, TextInput } from 'grommet';
import React, {useState} from 'react';
import {
    IconCopy,
    IconLink
} from '@tabler/icons-react'
import FontAwesomeIcon from './FontAwesomeIcon';
import Button from './Button';

const CopyLinkWidget = ({
    link,
    containerProps,
    copyLabel,
    icon,
    textProps
}) => {
    const [isClicked, setIsClicked] = useState(false);

    const copyLink = async () => {
        await navigator.clipboard.writeText(link);
        setIsClicked(true);
        setTimeout(() => {
            setIsClicked(false); // reset tooltip text
        }, 1000);
    };

    return (
        <Box
            background="background"
            wrap
            fill="horizontal"
            gap="xsmall"
            direction="row"
            responsive={false}
            border
            justify="between"
            align='center'
            round="xsmall"
            pad={{left: 'xxsmall'}}
            {...containerProps}>
            <Box direction="row" flex margin={{left: 'xsmall'}} align="center">
                <FontAwesomeIcon SelectedIcon={icon || IconLink} bold={!icon} size="small" color="text-xweak" />
                <TextInput size="small" value={link} plain {...textProps}/>
            </Box>
            {/* Flush to the widget's right edge and full height, so the hover
                background fills the end of the field up to its rounded corners */}
            <Box
                border={{side: "left"}}
                alignSelf="stretch"
                // Sits inside the 1.5px border, so its radius is the outer
                // xsmall (6px) minus the border to follow the same curve
                round={{corner: 'right', size: '4.5px'}}
                overflow="hidden"
            >
                <Button
                    event={{section: 'copy_link_widget', element: 'copy', description: link}}
                    tip={isClicked ? "Copied!" : "Copy link"}
                    hoverIndicator
                    onClick={copyLink}
                    plain
                    fill="vertical"
                    label={copyLabel ? copyLabel :
                        (<Box fill="vertical" justify="center" pad={{vertical: 'xsmall', horizontal: 'xsmall'}}>
                            <FontAwesomeIcon SelectedIcon={IconCopy} size="xsmall" color="text-weak" />
                        </Box>)
                    } />
            </Box>
        </Box>
    );
}

export default CopyLinkWidget;